var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_145",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#BE7878"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_145)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FF5144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.8147e-06 0C-3.8147e-06 3.15173 0.620773 6.27259 1.82689 9.1844C3.033 12.0962 4.80083 14.742 7.02943 16.9706C9.25804 19.1992 11.9038 20.967 14.8156 22.1731C17.7274 23.3792 20.8483 24 24 24L24 0H-3.8147e-06Z",
    fill: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 48 0)",
    fill: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 0C48 3.15173 47.3792 6.27259 46.1731 9.1844C44.967 12.0962 43.1992 14.742 40.9706 16.9706C38.742 19.1992 36.0962 20.967 33.1844 22.1731C30.2726 23.3792 27.1517 24 24 24L24 0H48Z",
    fill: "#1D1F22"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    fill: "#FF5144"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 24,
    height: 12,
    fill: "#1D1F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 29.3726 24 36H0C0 29.3726 5.37258 24 12 24Z",
    fill: "#1D1F22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 48 24)",
    fill: "#1D1F22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 12,
    transform: "matrix(-1 0 0 1 48 24)",
    fill: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 48C29.3726 48 24 42.6274 24 36H48C48 42.6274 42.6274 48 36 48Z",
    fill: "#FFC1DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderIcon);
export default __webpack_public_path__ + "static/media/placeholder_icon.fd94a0c5de8dc80366ffd4fad91d52b9.svg";
export { ForwardRef as ReactComponent };